import React from "react";
import styled from "styled-components";
import { SlotGrid } from "components/games/SlotGames/elements";
import { useMediaQuery } from "react-responsive";
import SlotGameCardNew from "components/new-games/SlotGameCardNew";
import useSlotGames, { FindSlotGamesSort } from "hooks/slots/useSlotGames";
import RevealSection from "components/common/RevealSection";
import Skeleton from "components/common/Skeleton";

export interface ISlotsComponent {
  id?: string;
}

export const SlotsComponent: React.FC<ISlotsComponent> = ({ id }): JSX.Element => {
  const xl = useMediaQuery({
    query: "(max-width: 1920px) and (min-width: 940px)",
  });
  const xxl = useMediaQuery({
    query: "(min-width: 1920px)",
  });
  let take = 6;
  if (xxl) take = 10;
  else if (xl) take = 8;

  const { data, isFetched } = useSlotGames({
    take,
    sort: FindSlotGamesSort.MOST_POPULAR,
  });
  const isReady = !!data && isFetched;

  return (
    <>
      <Box id={id} className="container">
        <RevealSection
          isReady={isReady}
          skeleton={
            <SectionSlotGrid>
              {Array.from({ length: take }).map((_, index) => (
                <Skeleton key={index} aspectRatio="3/4" radius="8px" />
              ))}
            </SectionSlotGrid>
          }
        >
          <SectionSlotGrid>
            {data?.data?.map?.((slot, index) => {
              return (
                <SlotGameCardNew
                  codeSlug={slot.codeSlug}
                  key={slot.code}
                  code={slot.code}
                  imageCode={slot.imageCode}
                  imageBgUrl={slot.imageBgUrl}
                  imageIconUrl={slot.imageIconUrl}
                  imageTextUrl={slot.imageTextUrl}
                  name={slot.name}
                  provider={slot.provider}
                  isFavorite={slot.isFavorite}
                  eager={index < EAGER_CARDS_COUNT}
                />
              );
            })}
          </SectionSlotGrid>
        </RevealSection>
      </Box>
    </>
  );
};

const EAGER_CARDS_COUNT = 6;

const Box = styled.div`
  padding: 16px;
`;

const SectionSlotGrid = styled(SlotGrid)`
  grid-template-columns: repeat(6, 1fr);

  @media (min-width: 1921px) {
    grid-template-columns: repeat(10, 1fr);
  }

  @media (max-width: 1920px) {
    grid-template-columns: repeat(8, 1fr);
  }

  @media (max-width: 939px) {
    grid-template-columns: repeat(5, 1fr);
  }

  @media (max-width: 767px) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media (max-width: 670px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 500px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;
